<p test-id="two-factor-auth-customer-service-text" data-test-id="two-factor-auth-customer-service-text">
	<span *ngIf="messageKey" [innerHtml]="(messageKey | translate) + ' '"></span>
	<a
		class="link"
		test-id="two-factor-auth-customer-service-btn"
		data-test-id="two-factor-auth-customer-service-btn"
		obgCustomerSupportLink
		(click)="customerSupportClick.emit()"
	>
		{{ "two-factor-auth.dialog.customer-service-btn" | translate }}
	</a>
</p>
